// extracted by mini-css-extract-plugin
export var footer = "_m0-5";
export var fulfillmentInput = "_m0-0";
export var shipDateInput = "_m0-1";
export var shipmentModal = "_m0-2";
export var shipmentModalContent = "_m0-3";
export var tableContainer = "_m0-4";